import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=f24ffe76&scoped=true"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=f24ffe76&prod&scoped=true&lang=css"
import style1 from "./ChatLayout.vue?vue&type=style&index=1&id=f24ffe76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24ffe76",
  null
  
)

export default component.exports